import React, { useMemo } from 'react'
import { TableListLoader } from 'src/components/Reusable/ContentLoaders/TableListLoader'
import { EmptyGrid, GridContainer } from 'src/components/Reusable/Grid'
import { EvidenceGroup } from '@trustero/trustero-api-web/lib/attachment/attachment_pb'
import { TabType } from 'src/components/Reusable/Tabs'
import { IndexingEvidenceSpinner } from '../../index/EvidenceIndexPage.components'
import { usePollEvidenceControlMappings } from '../../evidence.hooks'
import { EVIDENCE_TABS } from './EvidenceTabs.constants'
import { EvidenceControlMappingsBody } from './controlmappings/EvidenceControlMappingsBody'

export const useEvidenceControlMappingsTabs = ({
  evidence,
}: {
  evidence?: EvidenceGroup
}): TabType | null => {
  const evidenceId = evidence?.getEvidenceId() || ''
  const { mappings, isPolling, isLoading } = usePollEvidenceControlMappings({
    evidenceIds: [evidenceId],
  })
  const mapping = useMemo(() => {
    if (mappings && mappings.length > 0) {
      return mappings[0]
    }
  }, [mappings])
  if (!evidence) {
    return null
  }
  const tabTitle = EVIDENCE_TABS.SUGGESTED_CONTROLS
  if (isLoading) {
    return {
      title: tabTitle,
      count: 0,
      body: (
        <GridContainer>
          {isPolling && <IndexingEvidenceSpinner />}
          <TableListLoader />
        </GridContainer>
      ),
    } as TabType
  }
  if (!mapping) {
    return {
      title: tabTitle,
      count: 0,
      body: (
        <GridContainer>
          {isPolling && <IndexingEvidenceSpinner />}
          <EmptyGrid message="There are no suggested controls for this evidence." />
        </GridContainer>
      ),
    } as TabType
  }
  return {
    title: tabTitle,
    count: mapping?.getSuggestedControlsList().length || 0,
    body: (
      <EvidenceControlMappingsBody mapping={mapping} isPolling={isPolling} />
    ),
  } as TabType
}
